import L from 'leaflet';

/**
 * UN solo control de capas por mapa, compartido por quien lo necesite.
 *
 * Antes cada ayudante creaba el suyo con `L.control.layers(...)`. Con una
 * sola capa opcional eso no se notaba, pero al agregar el radar aparecían
 * dos cajitas apiladas en la misma esquina, cada una con una casilla, como
 * si fueran ajustes de cosas distintas. Son lo mismo: qué se ve encima del
 * mapa.
 *
 * El control vive en un WeakMap contra el objeto del mapa, así que cuando
 * el mapa se destruye al desmontar el componente, esto se va con él sin
 * dejar nada colgado.
 */
const controles = new WeakMap<L.Map, { control: L.Control.Layers; capas: number }>();

/**
 * Registra una capa opcional y devuelve su función de limpieza.
 *
 * El control se crea con la primera capa y se retira con la última: un
 * mapa sin nada opcional que ofrecer no enseña una caja vacía.
 */
export function agregarSuperposicion(map: L.Map, capa: L.Layer, etiqueta: string): () => void {
  let entrada = controles.get(map);
  if (!entrada) {
    entrada = {
      // autoZIndex apagado a propósito. Viene encendido de fábrica y hace
      // algo razonable pero indeseable aquí: al registrar cada capa le
      // reasigna el z-index para conservar el orden de la lista. Eso pisaba
      // el que el radar se pone a sí mismo para quedar por encima de la
      // ortofoto, y la lluvia desaparecía debajo de la imagen del cliente
      // sin ningún error de por medio. Aquí el orden lo decide cada capa.
      control: L.control.layers(undefined, {}, { collapsed: false, autoZIndex: false }),
      capas: 0,
    };
    entrada.control.addTo(map);
    controles.set(map, entrada);
  }
  entrada.control.addOverlay(capa, etiqueta);
  entrada.capas++;

  return () => {
    const actual = controles.get(map);
    if (!actual) return;
    actual.control.removeLayer(capa);
    capa.remove();
    if (--actual.capas <= 0) {
      actual.control.remove();
      controles.delete(map);
    }
  };
}
